/**
 * Фиксированное меню в шапке сайта
 */
class FixedMenu {

  /**
   * 
   * @param {Object} options 
   * @param {String} options.selector Селектор меню
   * @param {Number} options.threshold  Поороговое значение прокрутки для показа/сокрытия
   */
  constructor(options) {
    this.options = options;
    this.menu = document.querySelector(options.selector);
    if (this.menu) {
      window.addEventListener('scroll', this._handleWindowScroll.bind(this));
    }
  }

  _handleWindowScroll() {
      // https://stackoverflow.com/questions/40897551/my-scroll-handler-javascript-doesnt-work-in-internet-explorer/40897596
      // window.pageYOffset vs window.scrollY
      
      // fixedMenu.classList.toggle('fixed-menu--visible', window.pageYOffset > headerHeight)
      (window.pageYOffset > this.options.threshold) ? 
        this.show():
        this.hide();
  }

  /**
   * Hides menu
   */
  hide() {
    this.menu.classList.remove('fixed-menu--visible');
  }

  /**
   * Shows menu
   */
  show() {
    this.menu.classList.add('fixed-menu--visible');
  }
}

export default FixedMenu;